import React from "react";
import { FormControl } from "react-bootstrap";
import SurveyCheckbox from "../components/SurveyCheckbox";
import SurveyField from "../components/SurveyField";
import { questionTypeLabels } from "../domain/survey.constants";
import { newQuestion } from "../domain/survey.factories";
import ChoiceQuestionFields from "./question-types/ChoiceQuestionFields";
import NumberQuestionFields from "./question-types/NumberQuestionFields";
import RatingQuestionFields from "./question-types/RatingQuestionFields";
import TextQuestionFields from "./question-types/TextQuestionFields";

const typeEditors = {
  single_choice: ChoiceQuestionFields,
  multi_choice: ChoiceQuestionFields,
  text: TextQuestionFields,
  number: NumberQuestionFields,
  rating: RatingQuestionFields,
};

const SurveyQuestionEditor = ({ question, index, errors = {}, readOnly, inspector = false, onChange }) => {
  const update = (key, value) => onChange({ ...question, [key]: value });
  const changeType = (type) => {
    const replacement = newQuestion(type, []);
    onChange({
      ...replacement,
      id: question.id,
      question: question.question,
      description: question.description,
      required: question.required,
      order: question.order,
    });
  };
  const TypeEditor = typeEditors[question.type];

  return (
    <section className={`survey-engine-question survey-engine-question-inspector ${Object.keys(errors).length ? "survey-engine-question-has-error" : ""}`}>
      <div className="survey-builder-settings-title">
        <strong>Question {index + 1} Settings</strong>
        <span>{question.id} · {questionTypeLabels[question.type]}</span>
      </div>
      {errors.id && <div className="survey-engine-validation-banner">{errors.id}</div>}
      <div className={`survey-engine-form-grid ${inspector ? "survey-engine-inspector-grid" : ""}`}>
        <SurveyField label="Question type" required error={errors.type}>
          <FormControl componentClass="select" value={question.type} disabled={readOnly} onChange={(event) => changeType(event.target.value)}>
            {Object.keys(questionTypeLabels).map((type) => <option key={type} value={type}>{questionTypeLabels[type]}</option>)}
          </FormControl>
        </SurveyField>
        <SurveyField label="Question" required error={errors.question}>
          <FormControl placeholder="Enter the question shown to customers" value={question.question || ""} disabled={readOnly} onChange={(event) => update("question", event.target.value)} />
        </SurveyField>
        <SurveyField label="Question description">
          <FormControl placeholder="Add optional helper text" value={question.description || ""} disabled={readOnly} onChange={(event) => update("description", event.target.value)} />
        </SurveyField>
      </div>
      <SurveyCheckbox id={`survey-required-${question.id}`} label="Required question" checked={question.required} disabled={readOnly} onChange={(checked) => update("required", checked)} />
      {TypeEditor && <TypeEditor question={question} errors={errors} readOnly={readOnly} update={update} inspector={inspector} />}
    </section>
  );
};

export default SurveyQuestionEditor;
